import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

var getOptions = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var commodityCode = _ref2.commodityCode,
        specCode = _ref2.specCode,
        _ref2$anonymous = _ref2.anonymous,
        anonymous = _ref2$anonymous === undefined ? false : _ref2$anonymous,
        _ref2$targetFieldCode = _ref2.targetFieldCodes,
        targetFieldCodes = _ref2$targetFieldCode === undefined ? [] : _ref2$targetFieldCode,
        _ref2$fieldValues = _ref2.fieldValues,
        fieldValues = _ref2$fieldValues === undefined ? {} : _ref2$fieldValues,
        _ref2$commodity = _ref2.commodity,
        commodity = _ref2$commodity === undefined ? null : _ref2$commodity;
    var ret;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (commodity) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return getConstraints({
              commodityCode: commodityCode,
              specCode: specCode,
              anonymous: anonymous
            });

          case 3:
            commodity = _context.sent;

          case 4:
            ret = {};

            if (commodity) {
              _context.next = 7;
              break;
            }

            return _context.abrupt('return', null);

          case 7:
            targetFieldCodes.map(function (targetFieldCode) {
              ret['' + targetFieldCode] = _getTargetOptions({
                targetFieldCode: targetFieldCode,
                commodity: commodity,
                fieldValues: fieldValues
              });
            });
            return _context.abrupt('return', ret);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getOptions(_x) {
    return _ref.apply(this, arguments);
  };
}();

import constraintHelper from './constraintHelper';
import _isUndefined from 'lodash.isundefined';
import getProperty from '@ali/get-value';
import getConstraints from './getConstraints';

export default {
  getOptions: getOptions
};

function _getTargetOptions(_ref3) {
  var targetFieldCode = _ref3.targetFieldCode,
      commodity = _ref3.commodity,
      fieldValues = _ref3.fieldValues;

  var constraints = commodity['constraint'] || commodity['constraints'];
  var constraint = constraints[targetFieldCode]; //目标配件的约束
  var constrantsResult = [];
  if (!constraint) {
    return getComponentValues(targetFieldCode) || [];
  }

  function getVal(fieldCode) {
    if (fieldValues[fieldCode]) {
      return fieldValues[fieldCode];
    } else if (getComponentValues(fieldCode)[0] && !_isUndefined(getComponentValues(fieldCode)[0].value)) {
      return getComponentValues(fieldCode)[0].value;
    }
    return '';
  }
  function getComponentValues(fieldCode) {
    return getProperty(commodity, 'components.' + fieldCode + '.' + fieldCode) || [];
  }

  //获取约束结果值
  function getConditionValues() {
    var conditionCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var conditionCodesArray = conditionCodes.split('|');
    return conditionCodesArray.map(function (conditionCode) {
      return getVal(conditionCode);
    });
  }

  for (var conditionCodes in constraint) {
    var values = getConditionValues(conditionCodes);
    //当前的条件值
    var condition = constraint[conditionCodes];
    var resultValues = constraintHelper.getResult(condition[values.join('|')]);
    if (resultValues && Array.isArray(resultValues.values) && resultValues.values.length) {
      //兼容rds的格式
      resultValues = constraintHelper.getResult(resultValues.values);
    }
    if (resultValues) {
      constrantsResult.push(resultValues);
    }
  }
  var collection = getComponentValues(targetFieldCode);
  if (constrantsResult.length) {
    if (collection && collection[0] && collection[0].max) {
      collection = constraintHelper.getRangeConfig(collection, constrantsResult, false);
    } else {
      collection = constraintHelper.getNoramlOptioinValues(collection, constrantsResult);
    }
  }
  return collection;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/commonbuy/index.js
// module id = 162
// module chunks = 0